import React, { useContext } from 'react';

import { MenuContext } from '../../context/Menu';
import Image from '../Image';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { RootStateType } from '@Store';
import { useNavigate } from 'react-router-dom';

const openMenuLogoStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '24px 16px',
};
const closeMenuLogoStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '20px 8px',
};

const LogoImg = styled('div')`
  display: flex;
  flex: 1;
  padding: 10px;
  cursor: pointer;
  height: 140px;
  width: 210px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  mix-blend-mode: multiply;
`;

function Logo() {
  const { isMenuOpen } = useContext(MenuContext);
  const containerStyle = isMenuOpen ? openMenuLogoStyle : closeMenuLogoStyle;
  const orgPublicData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { logo = '', name = '' } = orgPublicData || {};
  const navigate = useNavigate();

  return (
    <div style={containerStyle} onClick={() => navigate('/')}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
        {isMenuOpen ? (
          <LogoImg style={{ backgroundImage: `url("${logo}")` }} />
        ) : (
          <Image
            src={logo}
            alt={name}
            width={80}
            height={80}
            style={{
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              mixBlendMode: 'multiply',
              objectFit: 'contain',
              maxWidth: '100%',
              maxHeight: '100%',
            }}
          />
        )}
      </div>
    </div>
  );
}
export default Logo;
